import(/* webpackMode: "eager", webpackExports: ["BackgroundImage"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/BackgroundImage/BackgroundImage.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Paper"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Paper/Paper.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SimpleGrid"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/SimpleGrid/SimpleGrid.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Stack"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Stack/Stack.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Text"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Text/Text.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Title"] */ "/vercel/path0/node_modules/@mantine/core/esm/components/Title/Title.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mantine/core/esm/core/Box/Box.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lang]/(landing)/components/LandingCard.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lang]/(landing)/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/LocalSelect.tsx");
